<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-click`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.29923 6.2101C6.39589 6.17302 6.53592 6.21041 6.81582 6.28541L10.4277 7.25326C10.8261 7.36001 11.0251 7.41373 11.0918 7.51405C11.1495 7.60099 11.1613 7.71082 11.1229 7.80782C11.0784 7.9197 10.8941 8.01295 10.5266 8.19994L9.21832 8.86592C9.10848 8.9218 9.05316 8.94968 9.00546 8.98666C8.96321 9.01943 8.92557 9.0577 8.8928 9.09994C8.85582 9.14764 8.8273 9.20237 8.77143 9.31218L8.10608 10.6211C7.91906 10.9887 7.82525 11.1723 7.71334 11.2168C7.61632 11.2552 7.50651 11.244 7.41956 11.1863C7.31922 11.1196 7.26557 10.9201 7.15877 10.5215L6.19155 6.90969C6.11667 6.63023 6.07874 6.49034 6.11561 6.39371C6.14798 6.30939 6.21491 6.24247 6.29923 6.2101ZM5.89217 0.821289C7.75018 0.821372 9.36885 1.84059 10.2223 3.34515C10.5087 3.85029 10.3315 4.49201 9.82641 4.77856C9.32129 5.06496 8.67956 4.88776 8.39301 4.38271C7.8979 3.50986 6.9626 2.92511 5.89217 2.92503C4.3058 2.92507 3.01976 4.21107 3.01976 5.79744C3.01992 6.906 3.64764 7.86987 4.57204 8.34932C5.08753 8.61676 5.28881 9.25163 5.02142 9.76716C4.75396 10.2825 4.11904 10.4838 3.60357 10.2165C2.00942 9.38971 0.916179 7.72191 0.916016 5.79744C0.916016 3.04948 3.14421 0.82133 5.89217 0.821289Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillClick',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
